// extracted by mini-css-extract-plugin
export default {"header":"AppHeader_header__fZxxn","headerText":"AppHeader_headerText__H1Erq","date":"AppHeader_date__yrDla","buttonContainer":"AppHeader_buttonContainer__m+BNK"};